<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Novo Departamento</div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label><span class="required">*</span> Departamento</label>
            <input type="text" class="form-control" v-model="department.title" />
          </div>
          <div class="col-md-6">
            <label>Gestor</label>
            <select class="form-control" v-model="department.menager">
              <option v-for="user in users" :key="user.id" :value="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label><span class="required">*</span> Descrição</label>
            <input style='height:100px' type="text" class="form-control" v-model="department.description" />
          </div>
        </div>
        <div class="mt-3 d-flex justify-content-between">
          <router-link to="/departments" class="btn btn-info">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-success" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      usersLoading: false,
      department: {
        title: "",
        description: "",
        menager: '',
      },
    };
  },
  methods: {
    save: function () {
      const self = this;

      if (self.department.id) return self.edit();

      const api = this.$store.state.api + "departments";

      let fd = self.makeFormData();
      if (!fd) return;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Departamento cadastrado com sucesso`,
            "success"
          );
          this.$router.push("/departments");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });

    },
    edit: function () {
      const self = this;
      const api = self.$store.state.api + "departments/" + self.department.id;

      let fd = self.makeFormData();
      if (!fd) return;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Departamento editado com sucesso`,
            "success"
          );

          this.$router.push("/departments");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeFormData: function () {
      const self = this;

      let fd = new FormData();

      fd.append("title", self.department.title);
      fd.append("description", self.department.description);
      fd.append("menager", self.department.menager);

      console.log(self.department.menager);


      if (self.department.id) {
        fd.append("id", self.department.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getDepartment: function (id) {
      let self = this;
      let api = self.$store.state.api + "departments/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.department = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getUser() {
      let self = this;
      const api =
        self.$store.state.api + "users";

      axios
        .get(api)
        .then((response) => {
          console.log(response);
          self.usersLoading = true;
          self.users = response.data.data;
        })
        .catch((error) => {
          // vm.$toast.error(error.response.data.message);
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getDepartment(id);
    }
    self.getUser();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Departments/Add.vue